module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: _vm.classes
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('spk-logo', {
    staticClass: "header__logo"
  })], 1), _vm._v(" "), (_vm.mobile) ? _c('ul', {
    staticClass: "header__social"
  }, _vm._l((_vm.social.accounts), function(account) {
    return _c('li', {
      staticClass: "header__account"
    }, [_c('a', {
      attrs: {
        "href": account.url,
        "target": "_blank"
      }
    }, [_c('icon', {
      attrs: {
        "id": account.icon
      }
    })], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('mobile-menu', {
    attrs: {
      "expand": _vm.expand,
      "links": _vm.links
    },
    on: {
      "menu-close": function($event) {
        _vm.expand = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mobile) ? _c('button', {
    staticClass: "burger",
    class: _vm.burgerState,
    on: {
      "click": function($event) {
        _vm.expand = !_vm.expand
      }
    }
  }, [_c('i', {
    staticClass: "burger--icon"
  })]) : _vm._e(), _vm._v(" "), (!_vm.mobile) ? _c('nav', [_vm._l((_vm.links), function(link) {
    return _c('router-link', {
      staticClass: "header__link",
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.label))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "header__link header__link--cta",
    attrs: {
      "to": "/infolettre"
    }
  }, [_c('icon', {
    attrs: {
      "id": "newsletter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Infolettre")])], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2361119a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/HeaderNav.vue
// module id = 628
// module chunks = 1